module.exports = __webpack_public_path__ + "static/media/bancolombia-pe-003-normal.4285062b.svg";